<!-- Modal: Linea de Credito -->
<div style="max-width: 520px; width: 100%;">
  <!-- Header -->
  <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 20px 24px; border-bottom: 2px solid #bfdbfe;">
    <h3 style="margin: 0; font-size: 1.1rem; font-weight: 800; color: #1e40af; display: flex; align-items: center; gap: 10px;">
      <mat-icon style="font-size: 24px; width: 24px; height: 24px; color: #2563eb;">
        {{ data.lineaCredito?.lineaCredito ? 'edit' : 'add_circle' }}
      </mat-icon>
      {{ data.lineaCredito?.lineaCredito ? 'Editar' : 'Crear' }} Linea de Credito
    </h3>
  </div>

  <!-- Content -->
  <div style="padding: 20px 24px;">
    <!-- Info del usuario -->
    <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 16px; margin-bottom: 20px;">
      <h4 style="font-size: 0.8rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px; margin: 0 0 12px 0; display: flex; align-items: center; gap: 6px;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">person</mat-icon>
        Informacion del Usuario
      </h4>
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
        <div>
          <span style="font-size: 0.7rem; color: #9ca3af; font-weight: 600; text-transform: uppercase;">ID Usuario</span>
          <p style="margin: 2px 0 0; font-size: 0.85rem; font-weight: 600; color: #374151; font-family: monospace;">{{ data.user }}</p>
        </div>
        <div>
          <span style="font-size: 0.7rem; color: #9ca3af; font-weight: 600; text-transform: uppercase;">Email</span>
          <p style="margin: 2px 0 0; font-size: 0.85rem; font-weight: 600; color: #374151; word-break: break-all;">{{ data.userEmail }}</p>
        </div>
      </div>
      <!-- Monto actual si existe -->
      <div *ngIf="data.lineaCredito?.lineaCredito" style="margin-top: 12px; padding-top: 12px; border-top: 1px solid #e5e7eb; display: flex; justify-content: space-between; align-items: center;">
        <span style="font-size: 0.85rem; font-weight: 600; color: #6b7280;">Monto Actual:</span>
        <span style="font-size: 1.1rem; font-weight: 800; color: #2563eb;">{{ data.lineaCredito?.lineaCredito | currency:'$':'symbol':'1.0-0' }} CLP</span>
      </div>
    </div>

    <!-- Formulario -->
    <form [formGroup]="createForm" (ngSubmit)="onSubmit()" *ngIf="createForm">
      <mat-form-field appearance="outline" class="w-full modern-field" style="margin-bottom: 8px;">
        <mat-label>{{ data.lineaCredito?.lineaCredito ? 'Nuevo monto' : 'Monto linea de credito' }}</mat-label>
        <mat-icon matPrefix style="color: #6b7280;">attach_money</mat-icon>
        <input matInput matInputCommified formControlName="lineaCredito" placeholder="Ingresa el monto" appOnlynumber pattern="[0-9]*">
      </mat-form-field>

      <!-- Info -->
      <div style="display: flex; align-items: flex-start; gap: 8px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 10px; padding: 10px 14px; margin-bottom: 8px;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0; margin-top: 1px;">info</mat-icon>
        <span style="font-size: 0.78rem; color: #1e40af; line-height: 1.4;">
          {{ data.lineaCredito?.lineaCredito ? 'Se actualizara el monto de la linea de credito existente.' : 'Se creara una nueva linea de credito para este usuario.' }}
        </span>
      </div>
    </form>
  </div>

  <!-- Footer -->
  <div style="padding: 16px 24px; border-top: 1px solid #e5e7eb; display: flex; gap: 10px; justify-content: flex-end;" class="flex-col sm:flex-row">
    <button type="button" (click)="closeDialog()"
      style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 10px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease; flex: 1;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">close</mat-icon>
      Cancelar
    </button>
    <button type="button" (click)="onSubmit()"
      [disabled]="createForm?.invalid"
      [style.opacity]="createForm?.invalid ? '0.5' : '1'"
      [style.cursor]="createForm?.invalid ? 'not-allowed' : 'pointer'"
      style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 10px 24px; background: #2563eb; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease; flex: 1;"
      onmouseover="if(!this.disabled)this.style.background='#1d4ed8'" onmouseout="if(!this.disabled)this.style.background='#2563eb'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">
        {{ data.lineaCredito?.lineaCredito ? 'save' : 'add_circle' }}
      </mat-icon>
      {{ data.lineaCredito?.lineaCredito ? 'Guardar Cambios' : 'Crear Linea de Credito' }}
    </button>
  </div>
</div>
